angular.module('spaceChat.common', [
  'ihestiaRestServicesBase'
]);
